import React from 'react';
import {
    Input,
    Button,
    Form,
    Switch
   } from "antd";
  import { useEffect, useState } from "react";
  import { useNavigate, useParams } from "react-router-dom";
  import * as Validation from "../../../../utils/helper/validation";
  import * as Apis from "../../../../utils/helper/enum";
  import globalRequest from "../../../../utils/global/globalRequest";
  import { changeLoader } from "../../../../redux/reducers/loader";
  import { useDispatch } from "react-redux";
  import toast from "react-hot-toast";


function Index({ walletToggle, setWalletToggle, setDefaultIndex }) {

    const navigate = useNavigate();
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const [couponToggle, setCouponToggle] = useState(false);
    let { id } = useParams();

      const handleInputChange = (name) => {
        form.setFields([
          {
            name,
            errors: [],
          },
        ]);
      };

      const handleSubmit = async (values, isAutoSubmit = false) => {
        const autoSubmit = typeof isAutoSubmit === 'boolean' ? isAutoSubmit : false;
        const couponAmount = values?.couponAmount !== undefined 
          ? values.couponAmount 
          : (couponToggle ? form.getFieldValue("couponAmount") : null);
        
        // Determine walletTopup: use passed value or current state
        const walletTopup = values?.walletTopup !== undefined 
          ? values.walletTopup 
          : walletToggle
        dispatch(changeLoader(true));
        try {
          let url = Apis?.MANAGE_VENDOR?.VENDOR_SETTINGS;
          let method = "put";
          let params = {
            vendor_id: id,
            couponAmount: couponAmount,
            walletTopup:  walletTopup,
          };
       
          let response = await globalRequest(url, method, {params:params}, {}, true);
          let apiResponse = response?.data;
          if (response?.status === 200) {
            let msg = "Settings updated successfully";
            // if (id) msg = "Vendor updated successfully";
            toast.success(msg, {
              duration: 2000,
            });
            if (!autoSubmit) {
              if (setDefaultIndex) {
                setDefaultIndex("1");
              } else {
                navigate("/manage-vendor");
              }
            }
          } else {
            toast.error(apiResponse?.message);
          }
        } catch (e) {
          toast.error(e?.message);
        }
        dispatch(changeLoader(false));
      };
    
  const getVendorDetail = async (id) => {
    try {
      let response = await globalRequest(
        Apis.MANAGE_VENDOR.GET_VENDOR_DETAIL + "/" + id,
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let data = apiResponse?.data;
        form.setFieldValue("couponAmount", data?.vendorDetail?.settings?.couponAmount)
        const amount = data?.vendorDetail?.settings?.couponAmount;
        const isWalletTopupEnabled = data?.vendorDetail?.settings?.walletToggle ? true : false;
        console.log("isWalletTopupEnabled", isWalletTopupEnabled);
          if (amount) {
            setCouponToggle(true); 
            form.setFieldValue("couponAmount", amount);
          }
          if (isWalletTopupEnabled) {
            setWalletToggle(true);
            form.setFieldValue("walletToggle", isWalletTopupEnabled);
          } else {
            setWalletToggle(false);
            form.setFieldValue("walletToggle", false);
          }
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  useEffect(() => {
    if (id) getVendorDetail(id);
  }, []);

      
  return (
    <>
      <div className="mb-0 flex justify-between flex-wrap w-[30%]">
        <Form.Item label="Enable Delivery Flat Cap Fees">
          <Switch
            checked={couponToggle}
            onChange={(checked) => {
              setCouponToggle(checked);
              
              if (!checked) {
                form.resetFields(["couponAmount"]);
              }
            }}
          />
        </Form.Item>

        <Form.Item label="Enable Wallet Topup">
          <Switch
            checked={walletToggle}
            onChange={(checked) => {
              setWalletToggle(checked);
            }}
          />
        </Form.Item>
        {/* {couponToggle && ( */}
        <Form
          layout="vertical"
          form={form}
          onFinish={handleSubmit}
        >
          {couponToggle && (
            <Form.Item
              label="Delivery Flat Cap Fees"
              name="couponAmount"
              rules={[
                {
                  required: true,
                  message: "Please enter Amount",
                },
              ]}
            >
              <Input
                size="Large"
                maxLength={10}
                addonAfter="SAR"
                onChange={(e) => {
                  let value = Validation.strFormat(e.target.value, "number");
                  form.setFieldValue("couponAmount", value.trimStart());
                  handleInputChange("couponAmount");
                }}
              />
            </Form.Item>
            )}
            <div className="flex justify-end gap-3">
              <Button onClick={() => navigate("/manage-vendor")}>Cancel</Button>
              <Button type="primary" htmlType="submit">Submit</Button>
            </div>
        </Form>
        {/* )} */}
      </div>
    </>
  );
}

export default Index;
